import axios from 'axios'
import gaEvent from 'utilities/tracking'
import { isLoading, setError } from 'containers/Checkout/actions'
import { API_SUBMIT_URL } from 'containers/Checkout/constants'

export const SUBMIT_LEAD_SUCCESS = 'SUBMIT_LEAD_SUCCESS'

export function submitLeadSuccess(next, reference) {
  return { type: SUBMIT_LEAD_SUCCESS, payload: { next, reference } }
}

export function submitLead() {
  return (dispatch) => {
    dispatch(isLoading(true))

    axios
      .post(API_SUBMIT_URL)
      .then((response) => {
        dispatch(submitLeadSuccess(response.data.next, response.data.reference))
      })
      .catch((error) => {
        dispatch(setError(true))
        const reason = (error.response.data && !error.response.data.success) ? 'Server Error' : 'Network Error'
        gaEvent('Error', {
          event_category: 'Web2case',
          event_label: reason,
          non_interaction: true,
        })
      })
  }
}



// WEBPACK FOOTER //
// ./containers/stages/SubmitStage/actions.js